import React from "react";
import { useNavigate } from "react-router-dom";

const ProjectCard = ({ title, image, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    setTimeout(() => {
      navigate(link);
    }, 300); 
  };

  return (
    <div className="project-card" onClick={handleClick} style={{ cursor: "pointer" }}>
      <img className="project-img" src={image} alt={title} />
    </div>
  );
};

export default ProjectCard;
